module.exports = __webpack_public_path__ + "img/avatar0.7b82393c.png";